// src/RingLoader.js
import React from 'react';

const RingLoader = () => {
  return <div id="global-loader" className="ring-loader"></div>;
};

export default RingLoader;
